import React from 'react';

export default function Select({ 
  label, 
  value, 
  onChange, 
  options = [],
  placeholder = 'Wybierz...',
  fullWidth = false,
  size = 'small',
  className = '',
  ...props 
}) {
  const sizeClasses = {
    small: 'px-2 py-1 text-xs',
    medium: 'px-4 py-1 text-sm',
  };

  const selectClasses = `
    ${sizeClasses[size]}
    ${fullWidth ? 'w-full' : ''}
    border border-gray-300 rounded-sm
    focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent
    transition-all duration-200
    bg-white
    ${className}
  `.trim().replace(/\s+/g, ' ');

  return (
    <div className={fullWidth ? 'w-full' : ''}>
      {label && (
        <label className="block text-xs font-normal text-gray-400 mb-1">
          {label}
        </label>
      )}
      <select
        value={value}
        onChange={onChange}
        className={selectClasses}
        {...props}
      >
        {placeholder && (
          <option value="" disabled>{placeholder}</option>
        )}
        {options.map((option, idx) => (
          <option key={idx} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}
